var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowsDefender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0370c8",
    d: "M24,44c-0.552,0-1-0.448-1-1s0.448-1,1-1V44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f5094",
    d: "M25,43c0,0.552-0.448,1-1,1v-2C24.552,42,25,42.448,25,43z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 11,
    r: 1,
    fill: "#0883d9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 11,
    r: 1,
    fill: "#33bff0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f5094",
    d: "M24,43l0.427,0.907c0,0,15.144-7.9,18.08-19.907H24V43z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0883d9",
    d: "M43,11l-1-1c-11.122,0-11.278-6-18-6v20h18.507C42.822,22.712,43,21.378,43,20C43,16.856,43,11,43,11 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0370c8",
    d: "M24,43l-0.427,0.907c0,0-15.144-7.9-18.08-19.907H24V43z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#33bff0",
    d: "M5,11l1-1c11.122,0,11.278-6,18-6v20H5.493C5.178,22.712,5,21.378,5,20C5,16.856,5,11,5,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsDefender);
export default __webpack_public_path__ + "static/media/WindowsDefender.00c310530a28522a35519150e7ccc121.svg";
export { ForwardRef as ReactComponent };